import React from "react";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import FormHistory from "./details/FormHistory";

const pathologyTabs = [
  { label: "Urine", type: "urine" },
  { label: "Parasitology", type: "parasitology" },
  { label: "Haematology", type: "haematology" },
  { label: "Chemical Pathology", type: "chemPathology" },
];

const PathologyLab = ({ patient }) => (
  <Tabs align="start" isLazy variant="unstyled">
    <TabList
      gap="1"
      p="1"
      overflowX="auto"
      bg="gray.100"
      borderRadius="xl"
      maxW="100%"
    >
      {pathologyTabs.map((item) => (
        <Tab
          key={item.type}
          flexShrink="0"
          px="4"
          py="2"
          borderRadius="lg"
          color="gray.600"
          fontWeight="700"
          _selected={{ bg: "white", color: "brand.700", boxShadow: "sm" }}
        >
          {item.label}
        </Tab>
      ))}
    </TabList>
    <TabPanels>
      {pathologyTabs.map((item) => (
        <TabPanel key={item.type} px="0" pt="6">
          <Box>
            <FormHistory
              patientData={patient}
              types={[item.type]}
              title={`${item.label} form history`}
              description={`Every ${item.label.toLowerCase()} form recorded for this patient, with its latest content and files.`}
              emptyTitle={`No ${item.label.toLowerCase()} forms yet`}
              emptyDescription={`${item.label} forms completed for this patient will appear here.`}
            />
          </Box>
        </TabPanel>
      ))}
    </TabPanels>
  </Tabs>
);

export default PathologyLab;
